export enum SaveStatus {
  SAVED = 'saved',
  SAVING = 'saving',
  ERROR = 'error'
}
